/* eslint-disable jsx-a11y/anchor-is-valid */
// eslint-disable-next-line react-hooks/exhaustive-deps
import { EyeOutlined, FormOutlined } from '@ant-design/icons';
import { Button, Card, Result, Space, Spin, Tooltip } from 'antd';
import * as moment from 'moment';
import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState
} from 'react';
import { useHistory } from 'react-router-dom';
import { SubSubtitle, Title } from '../../components';
import CustomAutocomplete from '../../components/CustomAutocomplete';
import LogosEmpresaAseguradora from '../../components/LogosEmpresaAseguradora';
import ResponsiveContainer from '../../components/ResponsiveContainer';
import TableAndFilters from '../../components/TableAndFilters';
import {
  SiniestroProvider,
  useSiniestroContext
} from '../../context/siniestro-context';
import UserContext from '../../context/user-context';
import { errorHandler } from '../../utils';
import { instanceRef } from '../../utils/axios';
import { fieldTypes, filterConditions } from '../../utils/filter-utils';
import ConfirmarDatos from './ConfirmarDatos';

const SiniestroProv = () => (
  <SiniestroProvider>
    <BuscarPolizas />
  </SiniestroProvider>
);

export default SiniestroProv;

const BuscarPolizas = () => {
  const {
    loadingSpin,
    setLoadingSpin,
    setDatosAsegurado
  } = useSiniestroContext();

  const tableRef = useRef();
  const confirmRef = useRef();
  const { user } = useContext(UserContext);

  const [persona, setPersona] = useState();
  const [personaViaContacto, setPersonaViaContacto] = useState();
  const [confirm, setConfirm] = useState(false);
  const [siniestroGenerado, setSiniestroGenerado] = useState(false);
  const [hash, setHash] = useState('');
  const history = useHistory();

  const mapOptions = ({ id: value, nombres_cedula: label }) => ({
    value,
    label
  });

  const fetchListClientes = (searchText) => {
    return instanceRef.instance.get(`/personas/search`, {
      params: {
        filters: {
          searchText,
          all: true
        }
      }
    });
  };

  const handleOpenUrl = (url) => {
    history.push(url);
  };

  const handleChange = (value) => {
    const updatedValue = { ...value };
    if (updatedValue.label) {
      updatedValue.cedula = updatedValue.label.split('-')[1]?.trim();
    }
    setConfirm(false);
    setPersona(updatedValue);
  };

  const handleChangeSiniestroGenerado = (token) => {
    setHash(token);
    setConfirm(false);
    setSiniestroGenerado(true);
    setPersona(null);
  };

  const getPolizaData = async (token) => {
    confirmRef.current.scrollIntoView({
      top: document.body.scrollHeight,
      left: 0,
      behavior: 'smooth'
    });
    try {
      setLoadingSpin(true);
      const res = await instanceRef.instance.get(`/poliza/${token}/plan`);
      setDatosAsegurado(res.data.data);
      setPersonaViaContacto(res.data.data?.persona?.via_contacto);
    } catch (err) {
      setLoadingSpin(false);
      errorHandler(err, err.message);
    }
    setLoadingSpin(false);
    setConfirm(true);
    confirmRef.current.scrollIntoView({
      behavior: 'smooth'
    });
  };

  const customFilters = (filtersTable) => {
    if (filtersTable.estado) {
      const tieneEstadoPendiente = filtersTable.estado.find(
        (item) => item === 'PENDIENTE'
      );
      if (tieneEstadoPendiente) {
        return {
          ...filtersTable,
          estado: [...filtersTable.estado, ...['CREADO', 'APROBADO']].filter(
            (item) => item !== 'PENDIENTE'
          )
        };
      }
      return {
        ...filtersTable,
        estado: filtersTable.estado.filter(
          (item) => item !== 'APROBADO' && item !== 'CREADO'
        )
      };
    }
    return filtersTable;
  };

  const formatFecha = (item) => {
    return moment(item).format('DD/MM/YYYY');
  };

  useEffect(() => {
    const setUser = async () => {
      if (user && user['cognito:groups'][0] === 'CLIENTE') {
        const res = await instanceRef.instance.get(
          `/personas/${user.sub}/persona`
        );
        setPersona({ cedula: res.data.data.cedula });
      }
    };
    setUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const renderDescripcion = (record, forExpandable = false) => {
    if (forExpandable) {
      if (record.producto.codigo === 1) {
        return (
          <div>
            <div>
              <span style={{ fontWeight: 'bold' }}>VEHICULO: </span>
              <span>
                {record.vehiculo.marca.descripcion} -{' '}
                {record.vehiculo.modelo.descripcion} -{' '}
                {record.vehiculo.aniosubmodelo.descripcion} -{' '}
                <span>{record.vehiculo.chapa}</span>
              </span>
            </div>
          </div>
        );
        // eslint-disable-next-line no-else-return
      } else if (record.producto.codigo === 4 || record.producto.codigo === 5) {
        return (
          <div>
            <div>
              <span style={{ fontWeight: 'bold' }}>DIRECCIÓN: </span>
              <span>
                {record.solicitud.inmueble.domicilio} -{' '}
                {record.solicitud.inmueble.distrito.descripcion} -{' '}
                {record.solicitud.inmueble.departamento.descripcion}
              </span>
            </div>
          </div>
        );
      }
      return (
        <div>
          <div>
            <span style={{ fontWeight: 'bold' }}>ASEGURADOS</span>
          </div>
          <div>
            {record.solicitud.asegurados.map((e) => (
              <div key={e.id}>
                {e.nombres} - {e.cedula} - {e.fecha_nacimiento}
              </div>
            ))}
          </div>
        </div>
      );
      // eslint-disable-next-line no-else-return
    } else {
      if (record.producto.codigo === 1 || record.producto.codigo === 7) {
        return `${record.vehiculo?.marca?.descripcion || ''}
            - ${record.vehiculo?.modelo?.descripcion || ''} -
            ${
              record.vehiculo?.aniosubmodelo
                ? record.vehiculo?.aniosubmodelo.descripcion
                : ''
            } -
            ${record.vehiculo?.chapa ? record.vehiculo.chapa : ''}`;
        // eslint-disable-next-line no-else-return
      } else if (
        record.producto.codigo === 4 ||
        record.producto.codigo === 5 ||
        record.producto.codigo === 6
      ) {
        return `${record.solicitud.inmueble.domicilio}
            - ${record.solicitud.inmueble.departamento.descripcion}`;
      }
      return `${
        record.solicitud.asegurados[0]
          ? record.solicitud.asegurados[0].nombres
          : record.persona.nombres
      }`;
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const columns = [
    {
      title: 'Número',
      dataIndex: 'numero',
      sortable: true,
      render: (_, record) =>
        record?.numero
          ? `${record.seccion || ''}-${record.numero || ''}-${
              record.endoso === null ? '' : record.endoso
            }`
          : 'SIN NÚMERO'
    },
    {
      title: 'Fecha Inicio Vigencia',
      dataIndex: 'fecha_inicio_vigencia',
      render: (item) => formatFecha(item),
      width: '10%'
    },
    {
      title: 'Fecha Fin Vigencia',
      dataIndex: 'fecha_fin_vigencia',
      render: (item) => formatFecha(item),
      width: '10%'
    },
    {
      title: 'Producto',
      dataIndex: ['producto', 'descripcion']
    },
    {
      title: 'Aseguradora',
      dataIndex: [
        'solicitud',
        'json_plan',
        'aseguradoraProducto',
        'aseguradora',
        'descripcion'
      ],
      width: '10%'
    },
    {
      title: 'Descripción',
      key: 'descripcion',
      render: (record) => renderDescripcion(record)
    },
    {
      title: 'Acciones',
      key: 'action',
      render: (text, record) => (
        <Space size="small">
          <Tooltip title="Ver póliza">
            <Button
              type="text"
              icon={<EyeOutlined />}
              size="middle"
              onClick={() => handleOpenUrl(`polizas/${record.token}`)}
            />
          </Tooltip>
          <Tooltip title="Continuar Denuncia de Siniestro">
            <Button
              type="text"
              icon={<FormOutlined />}
              size="middle"
              onClick={() => getPolizaData(record.token)}
            />
          </Tooltip>
        </Space>
      )
    }
  ];

  const Table = useCallback(() => {
    return (
      <TableAndFilters
        ref={tableRef}
        url="/poliza/vigentes"
        title="Pólizas Vigentes"
        columns={columns}
        defaultFilters={{
          'persona.cedula': {
            value: persona.cedula,
            filterType: fieldTypes.STRING,
            filterCondition: filterConditions.EQUALS
          }
        }}
        customFilters={customFilters}
        showTable
      />
    );
  }, [columns, persona?.cedula]);

  return (
    <>
      <LogosEmpresaAseguradora />
      <ResponsiveContainer>
        <Card>
          {!siniestroGenerado && (
            <>
              <br />
              <Title>Denuncia de Siniestros</Title>{' '}
              {user && user['cognito:groups'][0] !== 'CLIENTE' ? (
                <>
                  {' '}
                  <SubSubtitle>
                    Seleccione un Cliente (El listado muestra clientes con
                    pólizas vigentes)
                  </SubSubtitle>
                  <CustomAutocomplete
                    placeholder="Buscar Cliente"
                    fetchOptions={fetchListClientes}
                    mapOptions={mapOptions}
                    onChange={handleChange}
                  />
                  <br />
                  <br />
                </>
              ) : (
                <SubSubtitle>Seleccione Póliza</SubSubtitle>
              )}
            </>
          )}
          <div style={{ marginTop: '0px' }}>{persona?.value && <Table />}</div>
          <div ref={confirmRef} style={{ paddingTop: '40px' }} />
          <div style={{ margin: '20px' }}>
            <Spin
              spinning={loadingSpin}
              delay={500}
              size="large"
              tip="Cargando..."
            >
              {confirm && (
                <ConfirmarDatos
                  handleChangeSiniestroGenerado={handleChangeSiniestroGenerado}
                  title="Confirmar Datos"
                  contact
                />
              )}
            </Spin>
          </div>
          {siniestroGenerado && (
            <Result
              status="success"
              title="¡Denuncia creada y enviada exitosamente!!"
              subTitle={`El asegurado y denunciante recibirán un e-mail y/o ${
                personaViaContacto === 'whatsapp'
                  ? 'mensaje por Whatsapp'
                  : 'SMS'
              } para continuar con el proceso.`}
              extra={[
                <Space>
                  <Button
                    type="outlined"
                    key="console"
                    onClick={() => window.location.reload()}
                  >
                    Cargar nuevo
                  </Button>
                  <Button
                    type="primary"
                    key="console"
                    onClick={() => {
                      window.location.href = `${window.location.origin}/denuncia-siniestro/${hash}`;
                    }}
                  >
                    Continuar Denuncia
                  </Button>
                </Space>
              ]}
            />
          )}
        </Card>
      </ResponsiveContainer>
    </>
  );
};
